/**
 * PURPOSE: Listens for specific actions and determines when a route change should be performed.
 */

// externals
import { push } from 'connected-react-router';

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { NavigationActions } from '@makemydeal/dr-activities-common';
import { DashNext } from '@makemydeal/dr-shared-store';
import * as navigationActionTypes from '@makemydeal/dr-dash-store/actionTypes/navigationActionTypes';
import { RouteValues } from '@makemydeal/dr-dash-store/routeConstants';
import type { DashStoreMiddleware, DashStoreMiddlewareApi } from '@makemydeal/dr-dash-store/types/appState';
import { RealState, scopedActionsCreators, scopedStateSelectors } from '@makemydeal/shared-scoped-store';

// config
import { accessoriesCatalogConfiguration } from '../activities/accessories-catalog';

function dispatchNavigation(store: DashStoreMiddlewareApi, routeIntent: string) {
    // Track which scope triggered the navigation
    const state = store.getState();
    const isDashboard = routeIntent === RouteValues.DASHBOARD;
    const primaryScopeId = scopedStateSelectors.getPrimaryScopeId(state as RealState);
    const scopeId = isDashboard ? primaryScopeId : undefined;

    store.dispatch(scopedActionsCreators.setNavigationScopeTarget(scopeId));
    // Dispatch route change to connected-react-router
    store.dispatch(push(routeIntent));
}

function processAction(action: AnyFSA, store: DashStoreMiddlewareApi) {
    switch (action.type) {
        // TODO: DASH - This needs to be analyzed further... I believe the original intention of this middleware was to navigate
        //              to specific routes instead of a generate route like this.
        case NavigationActions.NAVIGATE_TO: {
            const routeIntent = action.payload;
            // TODO: DASH - restore as needed
            // const state = store.getState();
            // const deskingUser = isDeskingUser(state);
            // const headerPosition = getHeaderPosition(state);
            // const deskingUser = true;
            // if (deskingUser) {
            dispatchNavigation(store, routeIntent);
            // }
            break;
        }
        case navigationActionTypes.DASH_START_ACCESSORIES_CATALOG: {
            dispatchNavigation(store, accessoriesCatalogConfiguration.defaultRoute);
            break;
        }

        default: {
            break;
        }
    }
}

export const navigationMiddleware: DashStoreMiddleware = (store) => (next: DashNext) => (action: AnyFSA) => {
    next(action);

    if (action && action.type) {
        processAction(action, store);
    }
};
